"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableHead = function (_a) {
    var cols = _a.cols;
    return (react_1.default.createElement("thead", null,
        react_1.default.createElement("tr", null, cols.map(function (row, index) { return (react_1.default.createElement("th", { key: row.key || index, className: row.className || '' }, row.label)); }))));
};
exports.default = TableHead;
//# sourceMappingURL=TableHead.js.map